import { useGetFormationsMutation, useGetFormationThematicsMutation, Formation, FormationCategory } from '@services';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export const useFormationTalkListPageVM = () => {
    const { categoryId } = useParams();
    const [formations, setFormations] = useState<Formation[]>([]);
    const [category, setCategory] = useState<FormationCategory | null>(null);

    const [getFormations, { isLoading: isLoadingFormations, data: formationsData }] = useGetFormationsMutation();
    const [getFormationThematics, { data: categoriesData }] = useGetFormationThematicsMutation();

    useEffect(() => {
        if (!categoryId) return;
        getFormations({ categoryId: parseInt(categoryId) });
        getFormationThematics(undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoryId]);

    useEffect(() => {
        if (formationsData) {
            setFormations(formationsData);
        }
    }, [formationsData]);

    useEffect(() => {
        if (categoriesData && categoryId) {
            const foundCategory = categoriesData.find((cat) => cat.id === parseInt(categoryId));
            if (foundCategory) {
                setCategory(foundCategory);
            }
        }
    }, [categoriesData, categoryId]);

    return {
        formations,
        category,
        isLoading: isLoadingFormations
    };
};
